import type { LocationDescriptor } from 'history';
import type { HTMLAttributes } from 'react';

export type CardItemBreedAttributeType = 'exercise' | 'education' | 'care' | 'sociability';

export interface CardItemBreedData {
  name?: string;
  image?: string;
  link?: LocationDescriptor;
  onClick?: () => void;
  attributes?: Record<CardItemBreedAttributeType, number>;
  loading?: boolean;
  lazyLoadImage?: boolean;
  footerText?: string;
  dontTruncate?: boolean;
  shrinkHeightMobile?: boolean;
}

export interface CardItemBreedProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onClick'>,
    CardItemBreedData {}
